import { render } from "./ServicesTable.vue?vue&type=template&id=f9b8299e"
import script from "./ServicesTable.vue?vue&type=script&lang=js"
export * from "./ServicesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__